import { render, staticRenderFns } from "./DocumentPreviewExpired.vue?vue&type=template&id=e9d2aa96&scoped=true"
import script from "./DocumentPreviewExpired.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewExpired.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewExpired.vue?vue&type=style&index=0&id=e9d2aa96&prod&lang=scss&scoped=true"
import style1 from "./DocumentPreviewExpired.vue?vue&type=style&index=1&id=e9d2aa96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d2aa96",
  null
  
)

export default component.exports